(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hof-size-guide-page"] && !Shopify.designMode) return;
  try {
    
  function hofPrepareSizeTables(root) {
    if (!root || root.dataset.tablesReady === 'true') return;
    root.dataset.tablesReady = 'true';

    root.querySelectorAll('table').forEach(function (table) {
      if (table.parentElement.classList.contains('hof-size-page__table-wrap')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'hof-size-page__table-wrap';
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', 'Scrollable size chart');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    var flag = function () {
      root.querySelectorAll('.hof-size-page__table-wrap').forEach(function (w) {
        w.dataset.scrollable = w.scrollWidth > w.clientWidth + 1 ? 'true' : 'false';
      });
    };
    flag();
    window.addEventListener('resize', flag);
  }

  document.querySelectorAll('.hof-size-page__content').forEach(hofPrepareSizeTables);
  document.addEventListener('shopify:section:load', function (event) {
    hofPrepareSizeTables(event.target.querySelector('.hof-size-page__content'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
